import { render } from "./TestimonialsContent.vue?vue&type=template&id=35cb7057&scoped=true&ts=true"
import script from "./TestimonialsContent.vue?vue&type=script&lang=ts"
export * from "./TestimonialsContent.vue?vue&type=script&lang=ts"

import "./TestimonialsContent.vue?vue&type=style&index=0&id=35cb7057&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35cb7057"]])

export default __exports__